export default {
    build(model) {
        const fieldNames = [];
        const fields = {};
        Object.keys(model).forEach((field) => {
            fieldNames.push(field);
            fields[field] = {
                name: field,
                value: model[field],
                pristine: false,
                valid: true,
                errors: {
                    required: false,
                    pattern: false,
                    maxLength: false,
                    minLength: false,
                    min: false,
                    max: false,
                    custom: false,
                }
            }
        });

        fields._fields = fieldNames;
        fields.isForm = true;
        fields.valid = true;
        fields.progress = false;
        return fields;
    },

    methods() {
        return {
            validateField(event, field) {
                let conditions = this._build_conditions(event.target);
                this._validate_field_by_conditions(conditions, field);
            },

            setCustomError(field) {
                field.errors.custom = true;
                field.valid = false;
            },

            validateForm(event, form) {
                event.preventDefault();
                form._fields.forEach((field) => this.validateFormField(event.target.form, form[field]));
                form.valid = true;
                for (let fieldName of form._fields) {
                    form.valid = form.valid && form[fieldName].valid;
                }
                if (form.valid) {
                    return this.extractedValues(form);
                }
                return false;
            },

            validateFormField(formTarget, field) {
                let conditions = false;
                for(let input of formTarget) {
                    if (input.id == field.name) {
                        conditions = this._build_conditions(input);
                    }
                }
                if(conditions) {
                    this._validate_field_by_conditions(conditions, field);
                }
            },




            extractedValues (form) {
                const result = {};
                form._fields.forEach((field) => {
                    let f = form[field];
                    result[field] = f.value;
                });
                return result;
            },

            _validate_field_by_conditions(conditions, field) {
                field.errors.custom = false;
                field.pristine = true;
                field.valid = true;
                for (let kind in conditions) {
                    let name = '_validate_' + kind;
                    field.errors[kind] = this[name](field.value, conditions[kind]);
                    field.valid = field.valid && !field.errors[kind];
                }
            },

            _build_conditions(element) {
                return {
                    required: element.required,
                    pattern: element.pattern,
                    maxLength: element.maxLength,
                    minLength: element.minLength,
                    min: element.min,
                    max: element.max,
                };
            },

            _validate_required(fieldValue, conditionValue) {
                return conditionValue && (fieldValue === null || fieldValue === undefined || fieldValue === '');
            },

            _validate_pattern(fieldValue, conditionValue) {
                return (conditionValue && !fieldValue.match(conditionValue));
            },

            _validate_maxLength(fieldValue, conditionValue) {
                return conditionValue >= 0 && fieldValue.length > conditionValue;
            },

            _validate_minLength(fieldValue, conditionValue) {
                return conditionValue >= 0 && fieldValue.length < conditionValue;
            },

            _validate_min(fieldValue, conditionValue) {
                return conditionValue && fieldValue < conditionValue;
            },

            _validate_max(fieldValue, conditionValue) {
                return conditionValue && fieldValue > conditionValue;
            }

        }
    },




}



//////////////////
// WEBPACK FOOTER
// ./node_modules/redbay-b2b-form/src/Form.js
// module id = LjKe
// module chunks = 0